import * as React from "react";
import { forwardRef } from "react";
const SvgCloseIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 44 44", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { width: 34.375, height: 2.063, x: 10.313, y: 8.938, fill: "currentColor", rx: 1.031, transform: "rotate(45 10.313 8.938)" }), /* @__PURE__ */ React.createElement("rect", { width: 34.375, height: 2.063, x: 8.938, y: 33, fill: "currentColor", rx: 1.031, transform: "rotate(-45 8.938 33)" }));
const ForwardRef = forwardRef(SvgCloseIcon);
export { ForwardRef as ReactComponent };
